import { render, staticRenderFns } from "./InsuranceForm.vue?vue&type=template&id=0fb7511a&scoped=true&"
import script from "./InsuranceForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceForm.vue?vue&type=style&index=0&id=0fb7511a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7511a",
  null
  
)

export default component.exports